import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from "@mui/material";
import Badge from '@mui/material/Badge';
import { PickersDay } from "@mui/x-date-pickers";
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import 'dayjs/locale/vi';
import { useNavigate } from 'react-router-dom';


const CompanyWorkSchedulePage = ({ workScheduleStore }) => {
    const [date, setDate] = useState(new Date())
    const [highlightedDays, setHighlightedDays] = useState([]);
    const navigate = useNavigate();

    let from_date = moment(date.$d).startOf('month').format('YYYY-MM-DD');
    let to_date = moment(date.$d).endOf('month').format('YYYY-MM-DD');

    useEffect(() => {
        workScheduleStore.getWorkSchedule(from_date, to_date);
    }, [])

    let workScheduleList = toJS(workScheduleStore.workScheduleList);

    const handleClick = async () => {
        let dot = workScheduleList?.map(item => {
            return Number(moment(item.start_at).format("DD"))
        })
        dot.unshift(0)
        setHighlightedDays(dot)
    }

    useEffect(() => {
        handleClick()
    }, [JSON.stringify(workScheduleList)])

    const renderDay = (day, _value, DayComponentProps) => {
        const isSelected =
            !DayComponentProps.outsideCurrentMonth &&
            highlightedDays.indexOf(day.date()) > 0;

        return (
            <Badge
                key={day.toString()}
                overlap="circular"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                badgeContent={isSelected ? <div className="w-[6px] h-[6px] bg-blue-500 rounded-full" /> : undefined}
            >
                <PickersDay {...DayComponentProps} />
            </Badge>
        );
    }
    return (
        <MainLayout initialValue={1}>
            <div className="px-5">
                <div className="font-bold text-[28px] leading-[29px]  ">
                    Lịch cơ quan
                </div>
            </div>
            <div className="pt-4">
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='vi' >
                    <div id="custom-datepicker">
                        <StaticDatePicker
                            displayStaticWrapperAs="desktop"
                            openTo="day"
                            value={date}
                            onChange={(newDate) => {
                                setDate(newDate)
                            }}
                            onMonthChange={(newValue) => {
                                let from_date = moment(newValue.$d).startOf('month').format('YYYY-MM-DD');
                                let to_date = moment(newValue.$d).endOf('month').format('YYYY-MM-DD');
                                workScheduleStore.getWorkSchedule(from_date, to_date);
                            }}
                            disableHighlightToday
                            renderInput={(params) => <TextField {...params} />}
                            renderDay={renderDay}
                            dayOfWeekFormatter={(day) => `${day}`}
                        />
                    </div>
                </LocalizationProvider>
                <div className="px-5">
                    {
                        workScheduleList?.map(item => {
                            return <div>
                                {moment(item.start_at).format("DD/MM/YYYY") === moment(date.$d).format("DD/MM/YYYY") ? <div className="my-2" onClick={() =>
                                    navigate(`/company-work-schedule/view/${item.schedule_code}`)
                                }>
                                    <div className="bg-[#F8F8F8] rounded-2xl py-4 px-[18px]" >
                                        <div className="font-[600] text-[#0073C7]">
                                            {item.start_at != null && item.end_at != null ? <div>{moment(item?.start_at).format("HH:mm")} tới {moment(item?.end_at).format("HH:mm")}</div> : <div>Bắt đầu lúc {moment(item?.start_at).format("HH:mm")}</div>}
                                        </div>
                                        <div className="font-[600] my-2" dangerouslySetInnerHTML={{ __html: item.event_notice }} />
                                        <div style={{ overflowWrap: 'anywhere' }}>

                                            {item.location.indexOf('http') != -1 ? <div>{item.location.slice(0, item.location.indexOf('http'))} <a href={item.location.slice(item.location.indexOf('http'))} target="_blank">{item.location.slice(item.location.indexOf('http'))}</a></div> : <div>{item.location}</div>}
                                        </div>
                                    </div>
                                </div> : ''}
                            </div>
                        })
                    }
                </div>


            </div>
        </MainLayout>
    );
};

export default inject(
    "workScheduleStore",
)(observer(CompanyWorkSchedulePage));
